export default __webpack_public_path__ + "static/media/edit.acf4f520.svg";